import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthSsoGuard } from '@core/guards/auth-sso/auth-sso.guard';
import { LegacyDefectReportsRedirectGuard } from '@core/guards/defect-reports-toggle/legacy-defect-reports-redirect.guard';
import { NewDefectReportsRedirectGuard } from '@core/guards/defect-reports-toggle/new-defect-reports-redirect.guard';
import { DefaultRouteRedirectGuard } from '@core/guards/hash-route-redirect/default-route-redirect.guard';
import { RolesGuard } from '@core/guards/roles/roles.guard';
import { UserRole } from '@core/models/user-profile.model';
import { NoNetworkComponent } from '@shared/components/no-network/no-network.component';
import { AppComponent } from './app.component';

const routes: Routes = [
  {
    path: 'check',
    loadChildren: () => import('./check/check.module').then((m) => m.CheckModule),
    canActivate: [AuthSsoGuard, RolesGuard],
    data: { requiredRole: [UserRole.SERVICE_MANAGER, UserRole.OFFICE_PERSONAL] }
  },
  {
    path: 'checklist',
    canActivate: [AuthSsoGuard],
    loadChildren: () => import('./checklist/checklist.module').then((m) => m.CheckListModule)
  },
  {
    path: 'calendar',
    canActivate: [AuthSsoGuard],
    loadChildren: () => import('./calendar/calendar-view.module').then((m) => m.CalendarViewModule)
  },
  {
    path: 'defect-reports',
    canActivate: [AuthSsoGuard, LegacyDefectReportsRedirectGuard],
    loadChildren: () => import('./defect-reports/defect-reports.module').then((m) => m.DefectReportsModule)
  },
  {
    path: 'defects',
    canActivate: [AuthSsoGuard, NewDefectReportsRedirectGuard],
    loadChildren: () =>
      import('./defect-reports-v2/defect-reports-v2-routing.module').then((m) => m.DefectReportsV2RoutingModule)
  },
  {
    path: 'overview',
    canActivate: [AuthSsoGuard, RolesGuard],
    loadChildren: () => import('./overview/overview.module').then((m) => m.OverviewModule)
  },
  {
    path: 'service-coverage',
    canActivate: [AuthSsoGuard],
    loadChildren: () =>
      import('./service-coverage/service-coverage-routing.module').then((m) => m.ServiceCoverageRoutingModule)
  },
  {
    path: 'workshop-history',
    canActivate: [AuthSsoGuard],
    loadChildren: () => import('./workshop-history/workshop-history.module').then((m) => m.WorkshopHistoryModule)
  },
  {
    path: 'history',
    canActivate: [AuthSsoGuard],
    loadChildren: () =>
      import('./workshop-history-v2/workshop-history-v2.module').then((m) => m.WorkshopHistoryV2Module)
  },
  {
    path: 'settings',
    canActivate: [AuthSsoGuard],
    loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsModule)
  },
  {
    path: 'mac-plan',
    redirectTo: 'service-coverage/plans'
  },
  {
    path: 'maintenance-plan',
    canActivate: [AuthSsoGuard],
    loadChildren: () =>
      import('./maintenance-plan/maintenance-plan-routing.module').then((m) => m.MaintenancePlanRoutingModule)
  },
  {
    path: 'no-network',
    component: NoNetworkComponent
  },
  {
    /** Redirect to default route if there is no match.
     * Default route is dynamically obtained based on feature flags.
     * At the same time, keep compatibility with old hashing route strategy. */
    path: '**',
    canActivate: [DefaultRouteRedirectGuard],
    component: AppComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
